import React from 'react';

import QuoteService from '../../services/quoteService';
import AccountManagerService from '../../services/Celcoin/accountManagerService';
import { getTranslations } from '../../services/languageUtils';

import CAD from '../../assets/imgs/CAD.png';
import EUR from '../../assets/imgs/EUR.png';
import JPY from '../../assets/imgs/JPY.png';
import USD from '../../assets/imgs/USD.png';

const coins = [
    /*
      Sem `mock`. Cada moeda trazia um valor de exemplo escrito aqui, usado quando a
      cotação falhava — e o saldo era CONVERTIDO por ele, sem nada indicando que a taxa
      era inventada. Aqui isso é pior que na tela de cotações: o número resultante parece
      um saldo.
    */
    {value:'USD', label: 'USD Dollar', image: USD},
    {value:'EUR', label: 'EUR Euro', image: EUR},
    {value:'CAD', label: 'Canadian dollar', image: CAD},
    {value:'JPY', label: 'Japanese yen', image: JPY},
];

// const futureBalance = [
//   {label: 'Today', value: 0.0},
//   {label: 'D+1', value: 0.0},
//   {label: 'D+2', value: 0.0},
//   {label: 'D+3', value: 0.0},
//   {label: 'D+4', value: 0.0}
// ]

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueBalance: 0.00,
      viewBalance: false,
      data: [],
      translations: {}
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.refresh();
    this.loadTranslations();
  }

  refresh() {
    let that = this;

    AccountManagerService.showBalance().then((res) => {
      that.setState({valueBalance: res.data.body.amount});
    });

    /*
      ── Por que as cotações não apareciam ──

      A condição era `sessionStorage.getItem('USD') === ""`. Numa sessão nova o item não
      existe e `getItem` devolve `null`, que nunca é igual a `""` — a busca NUNCA acontecia.
      Caía-se no ramo do cache, e ali `sessionStorage.getItem(...)` devolvia `null`, em que
      `.replace` estoura: `TypeError` no meio do carregamento da home.

      A condição certa é "não tenho valor guardado".
    */
    const emCache = coins.every((moeda) => sessionStorage.getItem(moeda.value));

    if (emCache) {
      that.setState({
        data: coins.map((moeda) => ({
          coin: moeda.value,
          value: String(sessionStorage.getItem(moeda.value)).replace('.', ','),
          image: moeda.image,
        })),
      });
      return;
    }

    // Uma promessa por moeda, resolvidas juntas, e o estado escrito UMA vez: antes cada
    // resposta mutava o array do estado e a ordem das linhas dependia de qual voltasse
    // primeiro.
    Promise.all(
      coins.map((moeda) =>
        QuoteService.getQuoteDays(moeda.value + '-BRL', 1)
          .then((res) => {
            const cotacao = Number(res?.data?.[0]?.ask);
            if (!Number.isFinite(cotacao) || cotacao <= 0) throw new Error('sem cotação');
            return { moeda, valor: cotacao.toFixed(2) };
          })
          .catch((err) => {
            console.error('Cotação indisponível para ' + moeda.value + '-BRL:', err);
            return { moeda, valor: null };
          }),
      ),
    ).then((resultados) => {
      resultados.forEach(({ moeda, valor }) => {
        if (valor) sessionStorage.setItem(moeda.value, valor);
      });

      /*
        Só entram as moedas COM cotação. Aqui a linha existe para converter o saldo, e uma
        moeda sem taxa não converte nada — mantê-la mostraria o saldo dividido por nada.
        Se nenhuma responder, a seção fica vazia, que é o estado honesto.
      */
      that.setState({
        data: resultados
          .filter(({ valor }) => valor)
          .map(({ moeda, valor }) => ({
            coin: moeda.value,
            value: valor.replace('.', ','),
            image: moeda.image,
          })),
      });
    });
  }

  formatCurrency = (amount, currencyCode, t) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: currencyCode,
    }).format(Number(amount));
  };

  render() {
    return (
      <section className="BalanceComponent" id="BalanceComponent">
        <span className="desktop">
          <div className="contentBalance">
            <div className="contentItemBalance" style={{marginRight: "40px"}}>
              <b>{this.state.translations.current_balance}</b><br/>
              <p className="label">{this.state.translations.brl}</p>
              <b>{(this.state.viewBalance ? this.formatCurrency(this.state.valueBalance.toFixed(2), "BRL") : "**********")} &nbsp;&nbsp;&nbsp;&nbsp;</b>
              {
                this.state.viewBalance &&
                <img
                  src={require("../../assets/imgs/open-eye.svg").default}
                  style={{display: "inline-block", cursor: "pointer"}}
                  alt={this.state.translations.icon_view_balance}
                  onClick={() => {this.setState({viewBalance: false})}} />
              }
              {
                !this.state.viewBalance &&
                <img
                  src={require("../../assets/imgs/close-eye.svg").default}
                  style={{border: "3px solid rgba(0,0,0,0)", display: "inline-block", cursor: "pointer"}}
                  alt={this.state.translations.icon_view_balance}
                  onClick={() => {this.setState({viewBalance: true})}} />
              }
            </div>
            <div className="contentItemBalance">
              <p className="label">{this.state.translations.automatic_conversion}</p>
              {
                this.state.data.map((item, index) =>
                  <div key={index} className="contentSubitemBalance">
                    <img src={item.image} alt={this.state.translations.icon_flag} className="imgSubitemBalance"/>
                    <span style={{fontSize: "14px"}}>{item.coin}</span><br/>
                    {/*
                      A taxa vem do PRÓPRIO item, não de um `find` pelo nome dentro do
                      mesmo array: a busca devolvia o item que já está na mão, e estourava
                      se ele não estivesse mais lá.
                    */}
                    {this.state.viewBalance ? this.formatCurrency(this.state.valueBalance / Number(item.value.replace(',', '.')), item.coin) : '**********'}
                  </div>
                )
              }
            </div>
          </div>
          <br/><br/><br/><br/><br/>
        </span>

        <span className="mobile">
          <div className="contentQuickActions">
            <p className="label" style={{textAlign: "left"}}>{this.state.translations.quick_actions}</p>

            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div className="contentButtonQuickActions">
                <img
                  src={require("../../assets/imgs/ic-transfer-act-white.png")}
                  alt={this.state.translations.icon_quick_actions}
                  onClick={() => {window.location.href = '/transfers/pix'}} />
                  {this.state.translations.pix}
              </div>

              <div className="contentButtonQuickActions">
                <img
                  src={require("../../assets/imgs/ico-account-white.png")}
                  alt={this.state.translations.icon_quick_actions}
                  onClick={() => {window.location.href = '/accounts/statements'}} />
                  {this.state.translations.account}
              </div>

              <div className="contentButtonQuickActions">
                <img
                  src={require("../../assets/imgs/ic-settings-white.png")}
                  alt={this.state.translations.icon_quick_actions}
                  onClick={() => {window.location.href = '/settingsAndSecurity'}} />
                  {this.state.translations.settings}
              </div>
            </div>
          </div>

          <div className="contentBalance">
            <div className="contentItemBalance" style={{marginRight: "40px"}}>
              <b>{this.state.translations.current_balance}</b><br/>
              <div className="label" style={{display: "flex", justifyContent: "space-between", width: "90%", borderBottom: "1px solid #C8CACC", paddingBottom: "10px", marginBottom: "10px", fontSize: "14px"}}>
                <span>
                  <b style={{color: "#000", fontSize: "18px"}}>{(this.state.viewBalance ? this.formatCurrency(this.state.valueBalance.toFixed(2), "BRL") : "**********")}</b>
                </span>
              {
                this.state.viewBalance &&
                <img
                  src={require("../../assets/imgs/open-eye.svg").default}
                  style={{display: "inline-block", cursor: "pointer"}}
                  alt={this.state.translations.icon_view_balance}
                  onClick={() => {this.setState({viewBalance: false})}} />
              }
              {
                !this.state.viewBalance &&
                <img
                  src={require("../../assets/imgs/close-eye.svg").default}
                  style={{border: "3px solid rgba(0,0,0,0)", display: "inline-block", cursor: "pointer"}}
                  alt={this.state.translations.icon_view_balance}
                  onClick={() => {this.setState({viewBalance: true})}} />
              }
              </div>
            </div>
            <div className="contentItemBalance">
              <p className="label">{this.state.translations.automatic_conversion}</p>
              {
                this.state.data.length > 0 &&
                <div className="contentSubitemBalance">
                  <img src={this.state.data[0].image} alt={this.state.translations.icon_flag} className="imgSubitemBalance"/>
                  <span style={{fontWeight: "bolder"}}>
                    {this.state.viewBalance ? this.formatCurrency(this.state.valueBalance / Number(this.state.data[0].value.replace(',', '.')), this.state.data[0].coin) : '**********'}
                  </span>
                </div>
              }
            </div>
          </div>
        </span>
      </section>
    );
  }
}

export default Item;
